<template lang="pug">
  app-modal(
    :titulo="'Visualizar mensagens'",
    @closeModal="closeModal()",
    :width="width",
    :height="700"
    :bodyStyle="{height: 'auto', padding: '0'}"
  )
    template(slot="body")
      app-modal-visualiza-pdf(
        v-if="showModalVisualizaPdf",
        @closeModal="closeModalVisualizaPdf",
        :titulo="tituloModal",
        :tipo="tipoModal",
        :conteudo="conteudoModal",
        :isVTN="false",
        :isImagem="isImagem"
        :tituloDocumento="tituloDocumento"
      )
      div.extra-margin-bottom(v-for="item in conversas", :key="item.id")
        p.bold
          | Notificação: &nbsp{{ item.assunto }}
        el-collapse(v-model='abaAtiva')
          el-collapse-item(
            v-for="msg in item.mensagemList",
            :key="msg.id",
            :name='msg.id',
          )
            template(slot="title")
              div.flex.title
                span {{ msg.nomeRemetente }}
                span &nbsp {{ msg.dataEnviadaFormatada }}

            el-row.margin-top
              p(v-html="msg.conteudo")

            el-row
              el-table(
                :data='msg.anexoList',
                stripe
              )
                div(slot='empty')
                  span Não há anexos disponíveis.
                el-table-column.td-column-anexo(
                  prop='nome',
                )
                el-table-column.td-column-anexo(
                  align="center",
                  width="85"
                )
                  template(slot-scope='scope')
                    app-action-button(
                      v-if="isMa || isAp"
                      :disabled="!isDocumentoParaVisualizacao(scope.row)"
                      :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                      :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                      icone="eye",
                      fontSize="18",
                      @click="abrirDocumento(scope.row)"
                    )
                    app-action-button(
                      icone="download",
                      nome="file_download",
                      @click="baixarAnexo(scope.row)",
                      hoverColor="#009f61",
                      text="Baixar anexo"
                    )
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import AppActionButton from '@/components/AppActionButton'
import AppModal from '@/components/AppModal'
import utils from '@/utils/utils'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'

const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppModal,
    AppActionButton,
    AppModalVisualizaPdf
  },

  props: {
    width: {
      type: Number,
      default: 850
    },
    conversas: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      abaAtiva: undefined,
      moment,
      isMa: process.env.ESTADO === 'ma',
      isAp: process.env.ESTADO === 'ap',
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false
    }
  },

  async mounted () {
    const item = this.conversas[this.conversas.length - 1]
    this.abaAtiva = item.mensagemList[item.mensagemList.length - 1].id
  },

  methods: {
    ...mapActions({
      baixarDocumento: 'conversas/baixarDocumento'
    }),
    closeModal () {
      this.$emit('closeModal')
    },
    formatData (mensagem) {
      if (mensagem.dataEnviadaFormatada) {
        return mensagem.dataEnviadaFormatada
      } else if (mensagem.dataEnviada) {
        return moment(mensagem.dataEnviada).format('DD/MM/YYYY')
      } else {
        return '-'
      }
    },
    baixarAnexo (anexo) {
      this.baixarDocumento(anexo)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    isExtensaoImagem (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO_MENSAGEM'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.isExtensaoImagem(documento)
      this.showModalVisualizaPdf = true
      this.tituloDocumento = 'Documento'
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  }
}

</script>

<style scoped lang="scss">

  .extra-margin-bottom {
    padding: 10px;
  }

  p.message {
    width: 80%;
    margin: 0 auto;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .bold {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppModalListaConversas.vue